module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_14_2.d5bd2ee6.jpeg";